import React, { useContext } from "react";
import { Button, Col, Row } from "react-bootstrap";
import axios from "../../../../config/axios";
import { showErrorToast } from "../../../../components/Toasts";
import { Form, Formik } from "formik";
import OnlineReservationDateRangePicker from "../../OnlineReservationDateRangePicker";
import { useTranslation } from "react-i18next";
import { navigateTo } from "../../../../global/navigationHelper";
import { OnlineReservationContext } from "../..";

const NewOnlineReservationPage = () => {
  const { t } = useTranslation("reservations");
  const { configuration } = useContext(OnlineReservationContext);

  const handleSubmit = (values) => {
    axios
      .post(`/online_reservations.json`, { online_reservation: values })
      .then(function (response) {
        navigateTo(`/reservations/${response.data.token}/booking-details`);
      })
      .catch(function () {
        showErrorToast(
          t("errors.reservation.from_to.missing", { ns: "errors" })
        );
      });
  };

  return (
    <Formik initialValues={{ from: null, to: null }} onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => (
        <Form autoComplete="false">
          <Row>
            <Col>
              <h2 className={"mb-3"}>{t("newOnlineReservation.bookNow")}</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <OnlineReservationDateRangePicker
                from={values.from}
                to={values.to}
                setFieldValue={setFieldValue}
                minimumStays={configuration?.minimum_stays}
                reservationYears={configuration?.reservation_years}
              />
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="primary"
                  type={"submit"}
                  disabled={!values.from || !values.to}
                >
                  {t("newOnlineReservation.searchAvailabilities")}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default NewOnlineReservationPage;
